<template>
  <div class="activityList">
    <div style="max-width:1400px;padding-bottom:100px">
      <div><img :src="metting" alt="" width="100%" /></div>


      <el-table :data="tableData" style="width: 100%"  :span-method="objectSpanMethod" border>
        <el-table-column prop="theme" label="" width="160" align='center'></el-table-column>
        <el-table-column prop="activeName" label="会议活动名称"></el-table-column>
        <el-table-column prop="activeTime" label="时间" width="130"  align='center'></el-table-column>
        <el-table-column prop="activeAddress" label="地点"></el-table-column>
        <el-table-column prop="activeBz" label="备注">
          <template slot-scope="scope">
            <div>详情点击</div>
            <a :href="scope.row.activeBz" target="_blank">  {{scope.row.activeBz}}</a>
          </template>
        </el-table-column>
    </el-table>

    </div>
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>活动列表</el-breadcrumb-item>
    </el-breadcrumb> -->
    <!-- <div class="operas">
      <el-button type="primary" :style="buttonStyle" @click="addActive">新增</el-button>
    </div> -->
    <!-- <el-table
      :data="tableData" style="width: 100%">
        <el-table-column prop="atyTheme" label="会议主题"></el-table-column>
        <el-table-column prop="atyDate" label="会议时间"></el-table-column>
        <el-table-column prop="atyPlace" label="会议地点"></el-table-column>
        <el-table-column prop="atyContent" label="会议描述"></el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)" type="text" size="small">修改</el-button>
            <el-button type="text" size="small" @click="del(scope.row)">删除</el-button>
          </template>
      </el-table-column>
    </el-table> -->
  </div>
</template>
<script>
import api from '@/api'
import tools from '../../utils/tools.js';
import metting from '@/assets/metting.png'
import metting2 from '@/assets/metting2.png'


export default {
  name: 'activityList',
  data() {
    return {
      metting:metting,
      tableData: [{
        theme:'植保论坛',
        activeName:'第十八届中国农药工业发展国际论坛',
        activeTime:'3月17日',
        activeAddress:'国家会展中心（上海）7.2 馆会议区',
        activeBz:'http://www.cac-conference.com/',
        isHb:true,
        hbNum:3
      },
      {
        theme:'植保论坛',
        activeName:'第十三届中国国际生物农药及生物防治技术发展论坛',
        activeTime:'3月18日',
        activeAddress:'国家会展中心（上海）7.2 馆会议区',
        activeBz:''
      },
      {
        theme:'植保论坛',
        activeName:'第七届全球农化行业CROs及CRAOs交流会',
        activeTime:'3月18日',
        activeAddress:'国家会展中心（上海）7.2 馆会议区',
        activeBz:''
      },

      {
        theme:'肥料论坛',
        activeName:'第十五届中国国际肥料发展与贸易论坛',
        activeTime:'3月17日',
        activeAddress:'国家会展中心（上海）1.2馆 FSHOW 会议区1',
        activeBz:'https://www.fshow.org/tqhy/index.shtml',
        isHb:true,
        hbNum:5
      },
      {
        theme:'肥料论坛',
        activeName:'FSHOW 肥料添加剂及增效剂论坛',
        activeTime:'3月17日',
        activeAddress:'国家会展中心（上海）1.2馆 FSHOW 会议区2',
        activeBz:''
      },
      {
        theme:'肥料论坛',
        activeName:'FSHOW 生物刺激剂创新发展论坛',
        activeTime:'3月18日',
        activeAddress:'国家会展中心（上海）1.2馆 FSHOW 会议区1',
        activeBz:''
      },
      {
        theme:'肥料论坛',
        activeName:'FSHOW 新型肥料发展与应用论坛',
        activeTime:'3月18日',
        activeAddress:'国家会展中心（上海）1.2馆 FSHOW 会议区1',
        activeBz:''
      },
      {
        theme:'肥料论坛',
        activeName:'FSHOW 海外肥料品牌专场对接会',
        activeTime:'3月18日',
        activeAddress:'国家会展中心（上海）1.2馆 FSHOW 会议区2',
        activeBz:''
      },
      {
        theme:'农业科技论坛',
        activeName:'论坛一：现代农业科技论坛',
        activeTime:'3月17日',
        activeAddress:'国家会展中心（上海）2.2 馆 AGTECH 会议区',
        activeBz:'http://cn.chinagrowtech.com/',
        isHb:true,
        hbNum:4
      },
      {
        theme:'农业科技论坛',
        activeName:'论坛三：现代温室智能化发展论坛',
        activeTime:'3月17日',
        activeAddress:'国家会展中心（上海）2.2 馆 AGTECH 会议区',
        activeBz:''
      },
      {
        theme:'农业科技论坛',
        activeName:'论坛二：种业发展与贸易论坛',
        activeTime:'3月18日',
        activeAddress:'国家会展中心（上海）2.2 馆 AGTECH 会议区',
        activeBz:''
      },
      {
        theme:'农业科技论坛',
        activeName:'论坛四：智能水肥一体化与灌溉企业对接交流会',
        activeTime:'3月18日',
        activeAddress:'国家会展中心（上海）2.2 馆 AGTECH 会议区',
        activeBz:''
      }

    ],
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {},
    }
  },
  mounted() {
    // this.getData()
  },

  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 0) {
          if (row.isHb) {
            return {
              rowspan: row.hbNum,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }

        if (columnIndex === 4) {
          if (row.isHb) {
            return {
              rowspan: row.hbNum,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }

      },
    addActive(val) {
      this.$router.push('/activityList/edit')
    },
    edit(val){
      this.$router.push({path: '/activityList/edit', query: {id: val.atyID}});
    },
    getData(){
      api.gethostactivitys({
          "atyTheme": "",
          "atyContent": "",
          "atyType": 0,
          "pageIndex": 1,
          "pageSize": 10,
      }).then((res) => {      
        if(res.data.code == '200'){
          var _data = res.data.data
            this.tableData = _data.list
        }
      })
    },
      del(val){
        this.$confirm('确定删除该活动？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          api.deleteactivity({atyID: parseInt(val.atyID) }).then(res => {
            if (res.data.code === 200) {
              this.$notify({
                title: '成功',
                message: '删除成功',
                type: 'success'
              });
              this.getData()
            }
          })
        }).catch(() => {});
    }

  }
}
</script>

<style lang="less" scoped>
.activityList{
  .operas{
    text-align: right;
    padding: 20px 0;
  }
  .cardItem{
      -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      display: flex;
      margin-bottom: 50px;
      padding: 20px;
      border-radius: 10px;
  }
  .cardItem .img{
      width:200px;
      height:200px;
      margin-right: 10px;
      text-align: center;
  }
  .cardItem .img img{
      max-width:100%;
      max-height:100%;
  }
  .rightBox{
    width: 65%;
    font-size:14px;
    position: relative;
    padding: 14px;
    p{
      padding-top:15px;
    }
    .bottom{
        padding-top: 20px;
    }
  }
  
  .mart30{
    padding-top:30px;
  }
  .blue{
    color:#409EFF
  }
  .cards{
    display: flex;
    flex-wrap: wrap;
    >li{
      padding: 0 20px;
      width: 50%
    }
  }
  @media screen and (max-width:540px){
    .cards>li{
      width: 100%;
      padding:0;
      .img{
        width:100px;
        height: auto;
      }
    }
    .rightBox{
      padding:0;
      font-size: 14px;
      >p{
        padding-top:10px;
      }
      .el-button{
        padding:8px 16px;
      }
    }
  }
}
</style>
